import { useIonRouter } from '@ionic/react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import RoutePath from '@custom-types/RoutePath';
import { getLoginStatus as getLoginStatusFn } from '@pages/Auth/service';
import { useSetPeopleId } from '@pages/People/queries';
import { generateRoute } from '@services/navigation-service';
import { setUser } from '@state/user';

const useIsAuthenticated = () => {
  const { push: pushRoute } = useIonRouter();
  const dispatch = useDispatch();
  useSetPeopleId();

  useEffect(() => {
    const effect = async () => {
      const user = await getLoginStatusFn();

      if (user?.userId) {
        dispatch(setUser(user));
        pushRoute(generateRoute(RoutePath.EventList));
      }
    };

    // skipcq: JS-0328
    effect();
  }, [dispatch, pushRoute]);
};

export default useIsAuthenticated;
